module.exports = __webpack_public_path__ + "img/FT.09d87229.png";